import React, { useState } from "react";
import { Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { Eye } from "lucide-react";

const SalaryCard = ({ title, value, subtitle, variant = "primary", icon, navigationPath }) => {
  const [isHovered, setIsHovered] = useState(false);
  const navigate = useNavigate();

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
    }).format(amount || 0);
  };

  const formatValue = (val) => {
    if (typeof val === "number" && title.toLowerCase().includes("salary")) {
      return formatCurrency(val);
    }
    return val;
  };

  const handleViewMore = () => {
    if (navigationPath) {
      navigate(navigationPath);
    }
  };

  return (
    <Card 
      className={`text-center mb-3 border-${variant} transition-all duration-300 hover:shadow-lg transform hover:scale-105 position-relative overflow-hidden ${navigationPath ? 'cursor-pointer' : ''}`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={handleViewMore}
      style={{ minHeight: '150px' }}
    >
      <Card.Body className="d-flex flex-column justify-content-center">
        {icon && (
          <div className={`text-${variant} mb-2`}>
            <i className={`fas fa-${icon} fa-2x`}></i>
          </div>
        )}
        <Card.Title className={`text-${variant}`}>
          {formatValue(value)}
        </Card.Title>
        <Card.Text className="mb-1">
          <strong>{title}</strong>
        </Card.Text>
        {subtitle && (
          <Card.Text className="text-muted small">
            {subtitle}
          </Card.Text>
        )}
        
        {/* View More Overlay */}
        {isHovered && navigationPath && (
          <div className="position-absolute m-1" style={{ top: '0', right: '0' }}>
            <div className="px-1 py-0 rounded d-flex align-items-center gap-1 fw-normal shadow-sm border" 
                 style={{ 
                   fontSize: '0.65rem',
                   backgroundColor: 'rgba(255, 255, 255, 0.15)',
                   color: 'white',
                   borderColor: 'rgba(255, 255, 255, 0.2)',
                   backdropFilter: 'blur(4px)',
                   WebkitBackdropFilter: 'blur(4px)',
                   padding: '1px 4px'
                 }}>
              <Eye size={10} />
              <span>View</span>
            </div>
          </div>
        )}
      </Card.Body>
    </Card>
  );
};

export default SalaryCard;